enum ELinkTarget {
    Top = '_top',
    Self = '_self',
    Blank = '_blank',
    Parent = '_parent',
}

export default ELinkTarget
